import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import styles from './MortgagePage.module.css'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import MortgageApplication from '../../components/MortgageApplication/MortgageApplication'
import { HeaderType } from '../../components/Header/types/Header'
import { FooterType } from '../../components/Footer/types/Footer'
import MortgageImage from '../../assets/images/MortgageImage.webp'
import RegistrationImage from '../../assets/images/RegistrationImage.webp'
import Icon from '../../components/Icon'
import Button from '../../components/UI/Button/Button'

export default function MortgagePage() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const updateWindowWidth = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth);
    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    };
  }, []);

  const buttonStyle = {
    width: windowWidth <= 767 ? '100%' : 'fit-content',
  };

  return (
    <>
      <Helmet>
        <title>Рассрочка | Восток Строй</title>
        <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" />
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vostokstroy.com/mortgage" />

        <meta property="og:title" content="Рассрочка | Восток Строй" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta property="og:image" content="https://vostokstroy.com/open-graphs/mortgage-opengraph.jpg" />
        <meta property="og:url" content="https://vostokstroy.com/mortgage" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Рассрочка | Восток Строй" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/mortgage-opengraph.jpg" />

        <link rel="icon" type="image/svg+xml" href="/favicons/main-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/main-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/main-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/main-fav-180x180.png" />
      </Helmet>
      <Header theme={HeaderType.Light} />

      <div className={styles.content}>
        <div className={styles.mortgage_header}>
          <div className={styles.mortgage_image}>
            <img src={MortgageImage} alt="" />
          </div>
          <MortgageApplication></MortgageApplication>
        </div>
        <div className={styles.mortgage_content}>
          <div className={styles.percent_wrapper}>
            <div className={styles.percent_header}>
              <h3>Главное&nbsp;&mdash; без переплат</h3>
              <p className='text_body_b2'>Стоимость квартиры разделяется на&nbsp;фиксированные платежи в&nbsp;зависимости от&nbsp;размера первого взноса. Никаких дополнительных платежей не&nbsp;потребуем.</p>
            </div>
            <div className={styles.percent_content}>
              <Icon name='percentIcon' width='306' height='196'/>
            </div>
          </div>
          <div className={styles.registration_wrapper}>
            <div className={styles.registration_content}>
              <div className={styles.registration_text_wrapper}>
                <h3>Оформить легко</h3>
                <p className='text_body_b2'>Рассрочка оформляется в&nbsp;несколько шагов с&nbsp;минимальным набором документов. Не&nbsp;потребуются справки о&nbsp;доходах, кредитная история или походы в&nbsp;банк&nbsp;&mdash; все максимально просто и&nbsp;удобно.</p>
              </div>
              <Link to="/flat/status">
                <Button colorType='gray' width='fit-content' roundType='small_rounded' style={buttonStyle}>Открыть квартиры</Button>
              </Link>
            </div>
            <div className={styles.registration_image}>
              <img src={RegistrationImage} alt="" />
            </div>
          </div>
          <div className={styles.info_wrapper}>
            <div className={styles.info_content_block}>
              <div className={styles.info_icon_wrapper}>
                  <Icon name='bankIcon' width='166' height='166'/>
              </div>
              <div className={styles.info_text_wrapper}>
                <h3>Не кредит</h3>
                <p>Мы&nbsp;не&nbsp;требуем подтверждения доходов, не&nbsp;проверяем кредитную историю и&nbsp;не&nbsp;заключаем кредитный договор.</p>
              </div>
            </div>
            <div className={styles.info_content_block}>
              <div className={styles.info_icon_wrapper}>
                  <Icon name='clockIcon' width='166' height='166'/>
              </div>
              <div className={styles.info_text_wrapper}>
                <h3>Большие сроки</h3>
                <p>Беспроцентная рассрочка оформляется до&nbsp;заселения в&nbsp;проект&nbsp;&mdash; если оформить услугу на&nbsp;старте продаж, то&nbsp;рассрочку получится взять на&nbsp;срок до&nbsp;четырех лет.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer theme={FooterType.Light} />
    </>
  )
}
